import interActive from '../interactive/interactive';

const element = document.querySelector('.hero .swiper-container');

const options =	{
	direction: 'horizontal',
	speed: 600,
	loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	longSwipes: false,
	shortSwipes: false,
	simulateTouch: false,
	allowTouchMove: false,
	autoplay: {
	    delay: 6000,
	    disableOnInteraction: false,
	}
};	

const createSwiper = element => options => new Swiper.default(element, options);

const hero = () => {
	console.log()
    if (element && !interActive()) {
        let swipert = createSwiper(element)(options);
    }
};

export default hero;